import React, { Component } from 'react';
import styles from './Loading.module.css';

class Loading extends Component {
  render() {
    return <div className={styles.loading} />;
  }
}

export default Loading;
